import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ManageCategoryContent from '../../components/categories/manage-categories-content';

const ContentCategoryManageContent = () => {
  const { id } = useParams();
  const pageTitle = 'Content / Category';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ManageCategoryContent id={id} />
    </AppLayout>
  );
};

export default ContentCategoryManageContent;
